import { SUBMISSION } from "../Action";

const intialState = {
  submission: {},
};
const SubmissionReducer = (state = intialState, action) => {
  switch (action.type) {
    case SUBMISSION.submission:
      return { ...state, submission: action.data };
    default:
      return state;
  }
};
export default SubmissionReducer;
